export const LOGIN_SUCCESS = 'Login/LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'Login/LOGIN_FAILURE';
export const LOGOUT_REQUEST = 'Login/LOGOUT_REQUEST';
export const RESET_LOGIN_PARAMS = 'Login/RESET_LOGIN_PARAMS';